/**
 * Formatter for creating an Element-Modifier class name; Used primarily for CSS module module style selector
 * e.g. code: style[em('container', 'collapsed`)] => style['container--collapsed']
 * @param element
 * @param modifier
 * @returns e.g. `element--modifier`
 */
export const em = (
    element: string,
    modifier: string | undefined | false | null
) => (modifier ? `${element}--${modifier}` : element);

/**
 * Formatter for creating an Block-Element-Modifier (BEM) class name;
 * @param block
 * @param element
 * @param modifier
 * @returns e.g. `block__element--modifier`
 */
export const bem = (
    block: string,
    element?: string,
    modifier?: string | false | null
) => (element ? `${block}__${em(element, modifier)}` : block);

/**
 * Formatter for creating an Block-Modifier (BEM) class name;
 * @param block
 * @param element
 * @param modifier
 * @returns e.g. `block--modifier`
 */
export const bm = (
    block: string,
    modifier?: string | false | null
) => (modifier ? `${block}--${modifier}` : block);

